import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export default function FAQAccordion({ faq }) {
  const [openIndex, setOpenIndex] = useState(null);

  if (!faq || faq.length === 0) return null;

  return (
    <div data-testid="faq-accordion" className="space-y-0 border border-slate-200 rounded-xl overflow-hidden">
      {faq.map((item, idx) => (
        <div
          key={idx}
          className={`${idx > 0 ? "border-t border-slate-200" : ""}`}
          data-testid={`faq-item-${idx}`}
        >
          <button
            onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
            data-testid={`faq-toggle-${idx}`}
            className="w-full flex items-start justify-between gap-4 px-5 py-4 text-left bg-white hover:bg-slate-50 transition-colors"
            aria-expanded={openIndex === idx}
          >
            <span className="font-heading font-semibold text-slate-800 text-base leading-snug">
              {item.question}
            </span>
            <span className="flex-shrink-0 mt-0.5 text-blue-600">
              {openIndex === idx ? (
                <Minus className="w-5 h-5" />
              ) : (
                <Plus className="w-5 h-5" />
              )}
            </span>
          </button>

          {openIndex === idx && (
            <div
              data-testid={`faq-answer-${idx}`}
              className="px-5 pb-5 pt-1 bg-slate-50 border-t border-slate-100"
            >
              <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
                {item.answer}
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
